import { gql } from "@apollo/client"

const UPDATE_AVAILABILITY_MUTATION = gql`
  mutation($input: UpdateAvailabilityInput!) {
    updateAvailability(input: $input) {
      no_of_slots_updated
      no_of_slots_skipped
      status
    }
  }
`

export { UPDATE_AVAILABILITY_MUTATION }
